// extracted by mini-css-extract-plugin
module.exports = {"Ownership":"ownership_Ownership__14Hvb","Title":"ownership_Title__3NUtk","ActionBar":"ownership_ActionBar__3MmER"};